module.exports = __webpack_public_path__ + "assets/41021f357a3ec8000d1369736a5e50b1.svg";